import { useState } from "react";
import {
  FaIdCard, FaSyncAlt, FaGraduationCap, FaRing, FaBaby, FaHome, FaExclamationTriangle,
  FaDove, FaUserClock, FaPhoneAlt, FaWhatsapp, FaMapMarkerAlt, FaArrowRight, FaBars,
  FaTimes, FaHardHat, FaTaxi, FaTools
} from "react-icons/fa";

// [icon, en title, ta title, en text, ta text]
const SVC = [
  [<FaIdCard />, "New Member Registration", "புதிய உறுப்பினர் பதிவு", "Guidance and help for eligible workers to register as members.", "தகுதியான தொழிலாளர்கள் உறுப்பினராக பதிவு செய்ய வழிகாட்டுதல்."],
  [<FaSyncAlt />, "Membership Renewal", "உறுப்பினர் புதுப்பித்தல்", "Renew your membership on time, without the paperwork confusion.", "உறுப்பினர் அட்டையை சரியான நேரத்தில் புதுப்பிக்க உதவி."],
  [<FaGraduationCap />, "Educational Assistance", "கல்வி உதவித்தொகை", "Apply for education assistance for children of registered workers.", "பதிவுசெய்த தொழிலாளர்களின் குழந்தைகளுக்கு கல்வி உதவி."],
  [<FaRing />, "Marriage Assistance", "திருமண உதவித்தொகை", "Information and application help for marriage assistance.", "திருமண உதவித்தொகைக்கு விண்ணப்பிக்க வழிகாட்டுதல்."],
  [<FaBaby />, "Maternity Assistance", "மகப்பேறு உதவித்தொகை", "Welfare guidance for eligible women workers during maternity.", "மகப்பேறு நல உதவித்தொகை பெற வழிகாட்டுதல்."],
  [<FaHome />, "Housing Assistance", "வீட்டு உதவித்தொகை", "Know the housing schemes available to members.", "உறுப்பினர்களுக்கான வீட்டு உதவி திட்டங்கள்."],
  [<FaExclamationTriangle />, "Accidental Death Assistance", "விபத்து மரண உதவி", "Support for the family in case of a member's accidental death.", "உறுப்பினர் விபத்தில் இறந்தால் குடும்பத்திற்கு உதவி."],
  [<FaDove />, "Natural Death Assistance", "இயற்கை மரண உதவி", "Application help for families of eligible deceased members.", "இறந்த உறுப்பினர் குடும்பத்திற்கு விண்ணப்ப உதவி."],
  [<FaUserClock />, "Monthly Pension", "மாதாந்திர ஓய்வூதியம்", "Pension information and guidance for aged members.", "வயதான உறுப்பினர்களுக்கு ஓய்வூதிய வழிகாட்டுதல்."],
];

const STEPS = [
  ["Contact us", "தொடர்பு கொள்ளுங்கள்", "Call, WhatsApp, or visit our Tenkasi office.", "தொலைபேசி, WhatsApp அல்லது தென்காசி அலுவலகம்."],
  ["Get guidance", "வழிகாட்டுதல்", "We explain the scheme requirements in simple words.", "திட்ட தேவைகளை எளிய வார்த்தைகளில் விளக்குகிறோம்."],
  ["Prepare documents", "ஆவணங்கள் தயார்", "We tell you exactly which documents you need.", "தேவையான ஆவணங்கள் என்னென்ன என்று சொல்கிறோம்."],
  ["Application support", "விண்ணப்ப உதவி", "We stay with you until the application is complete.", "விண்ணப்பம் முடியும் வரை உங்களுடன் இருக்கிறோம்."],
];

const CSS = `
@import url('https://fonts.googleapis.com/css2?family=Manrope:wght@400;500;600;700;800&family=Noto+Sans+Tamil:wght@400;500;600;700&display=swap');
.sw{--ink:#0B1626;--paper:#F4F6F9;--mut:#5B6B80;--line:#E2E7EE;--ac:#F26B21;font-family:'Manrope','Noto Sans Tamil','Segoe UI',sans-serif;color:var(--ink);background:var(--paper);min-height:100vh;overflow-x:hidden}
.sw.ta{font-family:'Noto Sans Tamil','Manrope',sans-serif;line-height:1.75}
.sw *{box-sizing:border-box}.sw button{font-family:inherit;cursor:pointer}
.sw-wrap{max-width:1200px;margin:0 auto;padding:0 5%}
.sw-nav{position:sticky;top:0;z-index:50;background:rgba(11,22,38,.92);backdrop-filter:blur(12px);border-bottom:1px solid rgba(255,255,255,.08)}
.sw-nav .sw-wrap{display:flex;align-items:center;justify-content:space-between;height:68px}
.sw-brand{display:flex;align-items:center;gap:12px;color:#fff;font-weight:800;cursor:pointer}
.sw-brand img{width:40px;height:40px;object-fit:contain;border-radius:8px;background:#fff}
.sw-links{display:flex;gap:4px}
.sw-link{background:none;border:0;color:#A9B7CA;font-size:14px;font-weight:600;padding:8px 14px;border-radius:8px}
.sw-link:hover,.sw-link.on{color:#fff;background:rgba(255,255,255,.08)}
.sw-right{display:flex;gap:10px;align-items:center}
.sw-lang{display:flex;border:1px solid rgba(255,255,255,.18);border-radius:8px;overflow:hidden}
.sw-lang button{background:none;border:0;color:#A9B7CA;font-size:12px;font-weight:700;padding:6px 11px}
.sw-lang button.on{background:#fff;color:var(--ink)}
.sw-btn{background:var(--ac);color:#fff;border:0;border-radius:10px;padding:13px 22px;font-weight:700;font-size:15px;display:inline-flex;align-items:center;gap:10px;transition:filter .15s;text-decoration:none}
.sw-btn:hover{filter:brightness(1.08)}
.sw-btn.ghost{background:transparent;border:1px solid rgba(255,255,255,.28);color:#fff}
.sw-burger{display:none;background:none;border:0;color:#fff;font-size:20px}
.sw-mob{position:fixed;top:68px;left:0;right:0;background:var(--ink);padding:12px 5% 20px;z-index:49}
.sw-mob button{display:block;width:100%;text-align:left;background:none;border:0;color:#fff;font-size:16px;font-weight:600;padding:14px 0;border-bottom:1px solid rgba(255,255,255,.08)}
.sw-hero{background:var(--ink);color:#fff;position:relative;overflow:hidden;padding:96px 0 88px}
.sw-hero:before{content:"";position:absolute;inset:0;background-image:linear-gradient(rgba(143,163,191,.09) 1px,transparent 1px),linear-gradient(90deg,rgba(143,163,191,.09) 1px,transparent 1px);background-size:56px 56px;-webkit-mask-image:linear-gradient(180deg,#000 30%,transparent 100%);mask-image:linear-gradient(180deg,#000 30%,transparent 100%)}
.sw-hero:after{content:"";position:absolute;width:640px;height:640px;right:-160px;bottom:-320px;background:radial-gradient(circle,rgba(242,107,33,.38),transparent 65%)}
.sw-hero-grid{position:relative;z-index:1;display:grid;grid-template-columns:1.1fr .9fr;gap:56px;align-items:center}
.sw h1{font-size:clamp(38px,5.4vw,72px);line-height:1.04;letter-spacing:-2.2px;font-weight:800;margin:0 0 22px}
.sw.ta h1{letter-spacing:0;line-height:1.35;font-size:clamp(32px,4.4vw,56px)}
.sw h1 span{color:#8FA3BF;display:block}
.sw-lead{color:#B6C3D4;font-size:18px;line-height:1.7;max-width:520px;margin:0 0 34px}
.sw-cta{display:flex;gap:12px;flex-wrap:wrap}
.sw-stats{display:flex;gap:44px;margin-top:52px;padding-top:28px;border-top:1px solid rgba(255,255,255,.14);flex-wrap:wrap}
.sw-stats b{display:block;font-size:30px;font-weight:800;letter-spacing:-1px}
.sw-stats small{color:#8FA3BF;font-size:13px}
.sw-find{background:#fff;color:var(--ink);border-radius:18px;padding:26px;box-shadow:0 40px 80px -30px rgba(0,0,0,.6)}
.sw-find h3{font-size:19px;font-weight:800;margin:0 0 4px}
.sw-find .s{color:var(--mut);font-size:13px;margin:0 0 18px}
.sw-seg{display:grid;grid-template-columns:repeat(3,1fr);gap:6px;background:#EEF1F5;padding:4px;border-radius:12px;margin-bottom:16px}
.sw-seg button{border:0;background:none;border-radius:9px;padding:10px 6px;font-size:12.5px;font-weight:700;color:var(--mut);display:flex;flex-direction:column;align-items:center;gap:5px}
.sw-seg button.on{background:#fff;color:var(--ink);box-shadow:0 1px 4px rgba(11,22,38,.12)}
.sw-chips{display:flex;flex-wrap:wrap;gap:8px;margin-bottom:16px}
.sw-chip{border:1px solid var(--line);background:#fff;border-radius:99px;padding:7px 13px;font-size:12.5px;font-weight:600;color:#33445C}
.sw-chip.on{background:var(--ink);border-color:var(--ink);color:#fff}
.sw-res{background:#F4F6F9;border-radius:12px;padding:16px;border-left:3px solid var(--ac)}
.sw-res b{display:block;font-size:15px;margin-bottom:4px}
.sw-res span{font-size:13.5px;color:var(--mut);line-height:1.6}
.sw-res .sw-btn{margin-top:14px;width:100%;justify-content:center;padding:12px}
.sw-sec{padding:88px 0}.sw-sec.white{background:#fff}
.sw-h2{font-size:clamp(28px,3.4vw,44px);letter-spacing:-1.2px;font-weight:800;margin:0 0 12px;line-height:1.12}
.sw.ta .sw-h2{letter-spacing:0;line-height:1.4}
.sw-sub{color:var(--mut);font-size:16px;line-height:1.7;max-width:560px;margin:0 0 44px}
.sw-bento{display:grid;grid-template-columns:repeat(6,1fr);gap:16px}
.sw-bc{background:#fff;border:1px solid var(--line);border-radius:18px;padding:28px;grid-column:span 2;transition:border-color .2s}
.sw-bc:hover{border-color:var(--ac)}.sw-bc.w4{grid-column:span 4}.sw-bc.w3{grid-column:span 3}
.sw-bc.hi{background:var(--ink);color:#fff;border-color:var(--ink)}.sw-bc.hi p{color:#B6C3D4}
.sw-ic{width:44px;height:44px;border-radius:12px;background:#FFF0E6;color:var(--ac);display:flex;align-items:center;justify-content:center;font-size:18px;margin-bottom:22px;flex-shrink:0}
.sw-bc.hi .sw-ic{background:rgba(242,107,33,.18)}
.sw-bc h4{font-size:17px;font-weight:700;margin:0 0 8px}.sw-bc p{font-size:14px;color:var(--mut);line-height:1.65;margin:0}
.sw-steps{display:grid;grid-template-columns:repeat(4,1fr);gap:28px}
.sw-step{border-top:2px solid var(--ink);padding-top:20px}
.sw-step i{font-style:normal;font-weight:800;font-size:13px;color:var(--ac)}
.sw-step h4{font-size:17px;font-weight:700;margin:8px 0}.sw-step p{font-size:14px;color:var(--mut);line-height:1.65;margin:0}
.sw-band{background:var(--ac);color:#fff;border-radius:22px;padding:48px;display:flex;justify-content:space-between;align-items:center;gap:24px;flex-wrap:wrap}
.sw-band h3{font-size:28px;font-weight:800;letter-spacing:-.6px;margin:0 0 6px}.sw-band p{margin:0;opacity:.92}
.sw-band .sw-btn{background:#fff;color:var(--ink)}
.sw-ph{background:var(--ink);color:#fff;padding:72px 0 60px}
.sw-ph .sw-h2{color:#fff}.sw-ph .sw-sub{color:#B6C3D4;margin:0}
.sw-rows{display:grid;grid-template-columns:1fr 1fr;gap:0 56px}
.sw-row{display:flex;gap:18px;padding:26px 0;border-bottom:1px solid var(--line)}
.sw-row .sw-ic{margin:0}.sw-row h4{font-size:17px;font-weight:700;margin:0 0 6px}.sw-row p{font-size:14px;color:var(--mut);line-height:1.65;margin:0}
.sw-two{display:grid;grid-template-columns:1fr 1fr;gap:16px}
.sw-panel{background:#fff;border:1px solid var(--line);border-radius:18px;padding:32px}
.sw-panel h4{font-size:13px;font-weight:700;color:var(--ac);margin:0 0 10px}.sw-panel p{margin:0;color:#33445C;line-height:1.75}
.sw-tiles{display:grid;grid-template-columns:repeat(3,1fr);gap:16px}
.sw-tile{background:#fff;border:1px solid var(--line);border-radius:16px;padding:26px}
.sw-tile .sw-ic{margin-bottom:16px}.sw-tile h4{font-size:17px;font-weight:700;margin:0 0 6px}
.sw-tile p{color:var(--mut);font-size:14px;line-height:1.65;margin:0 0 12px}
.sw-tile a,.sw-tile div{color:var(--ink);font-weight:700;text-decoration:none;font-size:15px}
.sw-form{max-width:600px;margin:40px auto 0;background:#fff;border:1px solid var(--line);border-radius:18px;padding:32px}
.sw-form h3{font-size:22px;font-weight:800;margin:0 0 18px}
.sw-in{width:100%;border:1px solid #D3DAE4;border-radius:10px;padding:12px 14px;font:inherit;font-size:14px;margin-bottom:12px;background:#fff;color:var(--ink)}
.sw-in:focus{outline:0;border-color:var(--ink);box-shadow:0 0 0 3px rgba(11,22,38,.08)}
.sw-foot{background:var(--ink);color:#8FA3BF;padding:56px 0 28px;font-size:14px}
.sw-fg{display:grid;grid-template-columns:1.4fr 1fr 1fr;gap:40px}
.sw-foot h5{color:#fff;font-size:14px;font-weight:700;margin:0 0 14px}
.sw-foot button{display:block;background:none;border:0;color:#8FA3BF;padding:5px 0;font-size:14px}
.sw-foot button:hover{color:#fff}
.sw-fb{display:flex;justify-content:space-between;gap:12px;flex-wrap:wrap;margin-top:40px;padding-top:22px;border-top:1px solid rgba(255,255,255,.1);font-size:13px}
.sw-wa{position:fixed;right:24px;bottom:24px;z-index:60;width:54px;height:54px;border-radius:50%;background:#25D366;color:#fff;display:flex;align-items:center;justify-content:center;font-size:26px;box-shadow:0 10px 24px rgba(0,0,0,.28)}
@media(max-width:900px){
.sw-links{display:none}.sw-burger{display:block}
.sw-hero{padding:64px 0}.sw-hero-grid{grid-template-columns:1fr;gap:40px}
.sw-bento,.sw-steps,.sw-rows,.sw-two,.sw-tiles,.sw-fg{grid-template-columns:1fr}
.sw-bc,.sw-bc.w3,.sw-bc.w4{grid-column:span 1}
.sw-steps{gap:20px}.sw-sec{padding:60px 0}.sw-band{padding:32px}
}
@media(max-width:560px){.sw-right .sw-btn{display:none}}
`;

export default function PublicWebsite({ publicPage, setPublicPage, onStaffLogin }) {
  const [lang, setLang] = useState("en");
  const [menu, setMenu] = useState(false);
  const [cat, setCat] = useState(0);
  const [pick, setPick] = useState(0);
  const [f, setF] = useState({ name: "", mobile: "", service: "", message: "" });
  const ta = lang === "ta";
  const t = (en, tm) => (ta ? tm : en);
  const go = (p) => { setPublicPage(p); setMenu(false); window.scrollTo({ top: 0, behavior: "smooth" }); };
  const wa = (msg) => window.open(`https://wa.me/918123454322?text=${encodeURIComponent(msg)}`, "_blank");

  const CATS = [
    [<FaHardHat />, "Construction Workers", "கட்டுமான தொழிலாளர்கள்"],
    [<FaTaxi />, "Drivers", "ஓட்டுநர்கள்"],
    [<FaTools />, "Manual Workers", "மற்ற தொழிலாளர்கள்"],
  ];
  const NAV = [
    ["home", t("Home", "முகப்பு")], ["services", t("Services", "சேவைகள்")],
    ["about", t("About", "எங்களை பற்றி")], ["contact", t("Contact", "தொடர்பு")],
  ];
  const sv = (i) => ({ ic: SVC[i][0], title: t(SVC[i][1], SVC[i][2]), text: t(SVC[i][3], SVC[i][4]) });

  const send = () => {
    if (!f.name || !f.mobile || !f.service) {
      alert(t("Please fill Name, Mobile Number and Service.", "பெயர், மொபைல் எண் மற்றும் சேவை தேர்ந்தெடுக்கவும்."));
      return;
    }
    wa(`Hello SBM Udhayam,\n\nName: ${f.name}\nMobile: ${f.mobile}\nService: ${f.service}\nMessage: ${f.message || "No additional message"}\n\nThank you.`);
  };

  const Head = ({ h, s }) => (
    <section className="sw-ph"><div className="sw-wrap"><h1 className="sw-h2">{h}</h1><p className="sw-sub">{s}</p></div></section>
  );

  return (
    <div className={`sw ${ta ? "ta" : ""}`} lang={lang}>
      <style>{CSS}</style>

      <nav className="sw-nav"><div className="sw-wrap">
        <div className="sw-brand" onClick={() => go("home")}>
          <img src="/sbm-logo.jpeg" alt="SBM Udhayam" /><span>SBM UDHAYAM</span>
        </div>
        <div className="sw-links">
          {NAV.map(([p, l]) => <button key={p} className={`sw-link ${publicPage === p ? "on" : ""}`} onClick={() => go(p)}>{l}</button>)}
        </div>
        <div className="sw-right">
          <div className="sw-lang">
            <button className={lang === "en" ? "on" : ""} onClick={() => setLang("en")}>EN</button>
            <button className={lang === "ta" ? "on" : ""} onClick={() => setLang("ta")}>தமிழ்</button>
          </div>
          <button className="sw-btn ghost" style={{ padding: "8px 14px", fontSize: 13 }} onClick={onStaffLogin}>{t("Staff Portal", "அலுவலர் உள்நுழைவு")}</button>
          <button className="sw-burger" onClick={() => setMenu(!menu)}>{menu ? <FaTimes /> : <FaBars />}</button>
        </div>
      </div></nav>

      {menu && <div className="sw-mob">{NAV.map(([p, l]) => <button key={p} onClick={() => go(p)}>{l}</button>)}</div>}

      {publicPage === "home" && (<>
        <section className="sw-hero"><div className="sw-wrap sw-hero-grid">
          <div>
            <h1>{t("Supporting workers.", "தொழிலாளர் நலம்")}<span>{t("Empowering families.", "குடும்ப நலம்")}</span></h1>
            <p className="sw-lead">{t("Clear, personal guidance for construction and unorganised workers applying for government welfare services in Tenkasi.", "கட்டுமானம் மற்றும் அமைப்புசாரா தொழிலாளர்களுக்கு அரசு நல சேவைகளில் தெளிவான, தனிப்பட்ட வழிகாட்டுதல்.")}</p>
            <div className="sw-cta">
              <button className="sw-btn" onClick={() => go("services")}>{t("Explore services", "சேவைகளை காண")} <FaArrowRight /></button>
              <button className="sw-btn ghost" onClick={() => go("contact")}>{t("Contact our team", "எங்களை தொடர்பு கொள்ளுங்கள்")}</button>
            </div>
            <div className="sw-stats">
              <div><b>9</b><small>{t("Welfare schemes", "நல திட்டங்கள்")}</small></div>
              <div><b>3</b><small>{t("Worker categories", "தொழிலாளர் வகைகள்")}</small></div>
              <div><b>Mon–Sat</b><small>9:30 – 6:30</small></div>
            </div>
          </div>

          <div className="sw-find">
            <h3>{t("Find the right scheme", "உங்களுக்கான திட்டம்")}</h3>
            <p className="s">{t("Pick your work type and what you need. We'll take it from there.", "உங்கள் தொழில் மற்றும் தேவையை தேர்ந்தெடுக்கவும்.")}</p>
            <div className="sw-seg">
              {CATS.map((c, i) => <button key={i} className={cat === i ? "on" : ""} onClick={() => setCat(i)}>{c[0]}{t(c[1], c[2])}</button>)}
            </div>
            <div className="sw-chips">
              {SVC.map((_, i) => <button key={i} className={`sw-chip ${pick === i ? "on" : ""}`} onClick={() => setPick(i)}>{sv(i).title}</button>)}
            </div>
            <div className="sw-res">
              <b>{sv(pick).title}</b><span>{sv(pick).text}</span>
              <button className="sw-btn" onClick={() => wa(`Hello SBM Udhayam,\n\nCategory: ${CATS[cat][1]}\nService: ${SVC[pick][1]}\n\nPlease guide me.`)}>
                <FaWhatsapp /> {t("Ask about this on WhatsApp", "WhatsApp-ல் கேளுங்கள்")}
              </button>
            </div>
          </div>
        </div></section>

        <section className="sw-sec"><div className="sw-wrap">
          <h2 className="sw-h2">{t("Every welfare benefit, one team.", "ஒவ்வொரு நல சலுகைக்கும் ஒரே குழு.")}</h2>
          <p className="sw-sub">{t("We guide you through each step of the government application process.", "அரசு விண்ணப்ப செயல்முறையின் ஒவ்வொரு படியிலும் வழிகாட்டுகிறோம்.")}</p>
          <div className="sw-bento">
            {[0, 2, 3, 4, 6, 8].map((n, k) => (
              <div key={n} className={`sw-bc ${["w4 hi", "", "", "w4", "w3", "w3"][k]}`}>
                <div className="sw-ic">{sv(n).ic}</div><h4>{sv(n).title}</h4><p>{sv(n).text}</p>
              </div>
            ))}
          </div>
          <div style={{ marginTop: 28 }}>
            <button className="sw-btn" style={{ background: "var(--ink)" }} onClick={() => go("services")}>{t("View all 9 services", "அனைத்து சேவைகளும்")} <FaArrowRight /></button>
          </div>
        </div></section>

        <section className="sw-sec white"><div className="sw-wrap">
          <h2 className="sw-h2">{t("From first call to approved application.", "முதல் அழைப்பிலிருந்து விண்ணப்பம் முடியும் வரை.")}</h2>
          <p className="sw-sub">{t("Four steps, and you are never on your own.", "நான்கு படிகள், நீங்கள் தனியாக இல்லை.")}</p>
          <div className="sw-steps">
            {STEPS.map((s, i) => (
              <div className="sw-step" key={i}><i>0{i + 1}</i><h4>{t(s[0], s[1])}</h4><p>{t(s[2], s[3])}</p></div>
            ))}
          </div>
        </div></section>

        <section className="sw-sec"><div className="sw-wrap">
          <div className="sw-band">
            <div><h3>{t("Not sure which scheme fits you?", "எந்த திட்டம் பொருந்தும் என்று தெரியவில்லையா?")}</h3><p>{t("Call us. Guidance is free.", "அழைக்கவும். வழிகாட்டுதல் இலவசம்.")}</p></div>
            <a className="sw-btn" href="tel:+918123454322"><FaPhoneAlt /> +91 81234 54322</a>
          </div>
        </div></section>
      </>)}

      {publicPage === "services" && (<>
        <Head h={t("Every scheme. Clear guidance.", "ஒவ்வொரு திட்டமும். தெளிவான வழிகாட்டுதல்.")} s={t("We help construction and unorganised workers get every government welfare benefit available to them.", "தொழிலாளர்களுக்கு கிடைக்கும் அனைத்து அரசு நல சலுகைகளையும் பெற உதவுகிறோம்.")} />
        <section className="sw-sec"><div className="sw-wrap"><div className="sw-rows">
          {SVC.map((_, i) => <div className="sw-row" key={i}><div className="sw-ic">{sv(i).ic}</div><div><h4>{sv(i).title}</h4><p>{sv(i).text}</p></div></div>)}
        </div></div></section>
      </>)}

      {publicPage === "about" && (<>
        <Head h={t("Built to support workers like you.", "உங்களைப் போன்ற தொழிலாளர்களுக்கான ஆதரவு.")} s={t("SBM Udhayam is a welfare support organisation in Tenkasi, Tamil Nadu. We help construction workers, drivers and other unorganised workers understand and access their government benefits, one person at a time.", "SBM உதயம் தென்காசியில் அமைந்த நல ஆதரவு அமைப்பு. தொழிலாளர்கள் தங்களுக்கு உரிய அரசு நல சேவைகளை புரிந்துகொண்டு பெற உதவுகிறோம்.")} />
        <section className="sw-sec"><div className="sw-wrap"><div className="sw-two">
          <div className="sw-panel"><h4>{t("Our mission", "எங்கள் நோக்கம்")}</h4><p>{t("To make welfare information accessible and understandable for every worker, and remove the barriers created by complex processes.", "ஒவ்வொரு தொழிலாளருக்கும் நல சேவை தகவல்களை புரிந்துகொள்ளக்கூடியதாக மாற்றுவது.")}</p></div>
          <div className="sw-panel"><h4>{t("Our vision", "எங்கள் தொலைநோக்கு")}</h4><p>{t("A Tamil Nadu where every unorganised worker gets the support they are entitled to, without confusion or delay.", "ஒவ்வொரு அமைப்புசாரா தொழிலாளரும் உரிய ஆதரவை தாமதமின்றி பெறும் தமிழ்நாடு.")}</p></div>
        </div></div></section>
      </>)}

      {publicPage === "contact" && (<>
        <Head h={t("We're here to help.", "உதவ நாங்கள் இருக்கிறோம்.")} s={t("Reach out for free guidance on any welfare scheme for construction and unorganised workers.", "எந்த நல திட்டத்திற்கும் இலவச வழிகாட்டுதலுக்கு தொடர்பு கொள்ளுங்கள்.")} />
        <section className="sw-sec"><div className="sw-wrap">
          <div className="sw-tiles">
            <div className="sw-tile"><div className="sw-ic"><FaPhoneAlt /></div><h4>{t("Call us", "அழைக்கவும்")}</h4><p>{t("Mon to Sat, 9.30am to 6.30pm.", "திங்கள் - சனி, 9.30 - 6.30.")}</p><a href="tel:+918123454322">+91 81234 54322</a></div>
            <div className="sw-tile"><div className="sw-ic"><FaWhatsapp /></div><h4>WhatsApp</h4><p>{t("Send a message and we'll reply quickly.", "செய்தி அனுப்பவும், விரைவில் பதில் அளிப்போம்.")}</p><a href="https://wa.me/918123454322" target="_blank" rel="noreferrer">{t("Chat now", "பேசுங்கள்")}</a></div>
            <div className="sw-tile"><div className="sw-ic"><FaMapMarkerAlt /></div><h4>{t("Visit us", "நேரில் வாருங்கள்")}</h4><p>{t("Come to our Tenkasi office for in-person help.", "தென்காசி அலுவலகத்திற்கு வாருங்கள்.")}</p><div>MelaMutharamman Kovil Street, Tenkasi 627 811</div></div>
          </div>
          <div className="sw-form">
            <h3>{t("Send a WhatsApp enquiry", "WhatsApp விசாரணை அனுப்புங்கள்")}</h3>
            <input className="sw-in" placeholder={t("Your name *", "உங்கள் பெயர் *")} value={f.name} onChange={(e) => setF({ ...f, name: e.target.value })} />
            <input className="sw-in" placeholder={t("Mobile number *", "மொபைல் எண் *")} value={f.mobile} onChange={(e) => setF({ ...f, mobile: e.target.value })} />
            <select className="sw-in" value={f.service} onChange={(e) => setF({ ...f, service: e.target.value })}>
              <option value="">{t("Select service *", "சேவை தேர்ந்தெடுக்கவும் *")}</option>
              {SVC.map((s) => <option key={s[1]} value={s[1]}>{ta ? s[2] : s[1]}</option>)}
            </select>
            <textarea className="sw-in" rows={3} placeholder={t("Message (optional)", "செய்தி (விருப்பமானது)")} value={f.message} onChange={(e) => setF({ ...f, message: e.target.value })} />
            <button className="sw-btn" style={{ width: "100%", justifyContent: "center" }} onClick={send}><FaWhatsapp /> {t("Send enquiry", "விசாரணை அனுப்பவும்")}</button>
          </div>
        </div></section>
      </>)}

      <footer className="sw-foot"><div className="sw-wrap">
        <div className="sw-fg">
          <div><h5>SBM UDHAYAM</h5>{t("Welfare service guidance for construction and unorganised workers. Tenkasi, Tamil Nadu.", "கட்டுமானம் மற்றும் அமைப்புசாரா தொழிலாளர்களுக்கு நல சேவை வழிகாட்டுதல். தென்காசி.")}</div>
          <div><h5>{t("Navigate", "வழிசெலுத்தல்")}</h5>{NAV.map(([p, l]) => <button key={p} onClick={() => go(p)}>{l}</button>)}</div>
          <div><h5>{t("Contact", "தொடர்பு")}</h5><div>+91 81234 54322</div><div style={{ marginTop: 6 }}>MelaMutharamman Kovil St, Tenkasi</div></div>
        </div>
        <div className="sw-fb"><span>© 2026 SBM Udhayam. {t("All rights reserved.", "அனைத்து உரிமைகளும் பாதுகாக்கப்பட்டவை.")}</span></div>
      </div></footer>

      <a className="sw-wa" href="https://wa.me/918123454322" target="_blank" rel="noreferrer" aria-label="WhatsApp"><FaWhatsapp /></a>
    </div>
  );
}
